import { useMemo } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Routes from '../../../../constants/routes';
import { world } from '../../../../languages';
import { AVAILABLE_WORLDS } from '../../../../languages/constants';
import qualityEvents from '../../../../services/quality-events';
import schedule from '../../../../utils/sale/schedule';
import './sale-bar.scss';

const FIRST_DAYS_TEXT = {
    [AVAILABLE_WORLDS.DE]: 'Flash Sale: 26 % Rabatt auf Materialien',
    [AVAILABLE_WORLDS.ES]: '📣 Flash Sale: ¡30% de descuento en materiales!',
    // [AVAILABLE_WORLDS.FR]: '',
    [AVAILABLE_WORLDS.GR]: '📣 Flash Sale: 30% έκπτωση σε όλο το εκπαιδευτικό υλικό!',
    [AVAILABLE_WORLDS.IT]: '📣 Flash Sale: 30% di sconto su tutti i materiali didattici!'
};

const LAST_DAY_TEXT = {
    [AVAILABLE_WORLDS.DE]: 'Nur heute: 26 % Rabatt auf Materialien',
    [AVAILABLE_WORLDS.ES]: '📣 Sólo hoy: ¡30% de descuento en materiales!',
    // [AVAILABLE_WORLDS.FR]: '',
    [AVAILABLE_WORLDS.GR]: '📣 30% έκπτωση σε όλο το εκπαιδευτικό υλικό - ΜΟΝΟ ΓΙΑ ΣΗΜΕΡΑ!',
    [AVAILABLE_WORLDS.IT]: '📣 SOLO OGGI: 30% di sconto su tutti i materiali didattici!'
};

const SaleBar = ({ history }: RouteComponentProps) => {
    const bannerText = useMemo(() => {
        if (schedule.saleLastDay) {
            return LAST_DAY_TEXT[world];
        }

        return FIRST_DAYS_TEXT[world];
    }, [schedule.saleLastDay]);

    const onBannerClick = () => {
        qualityEvents.track({
            extra: JSON.stringify({
                user_id: window.storage.getItem('userId')
            }),
            type: 'flash-sale-2025'
        });
        setTimeout(() => {
            history.push(Routes.SEARCH_RESULT.path);
        }, 200);
    };

    return (
        <div
            className='sale-bar cursor-pointer d-flex justify-content-center align-items-center'
            onClick={onBannerClick}
        >
            <span className='sale-bar-text text-center'>
                <span className='sale-bar-text text-center' dangerouslySetInnerHTML={{ __html: bannerText }} />
            </span>
        </div>
    );
};

export default withRouter(SaleBar);
